module.exports = __webpack_public_path__ + "img/crea-tu-cuenta-y-entra-al-juego.330b9b1d.png";